import React from 'react';
import { Row, Divider, Col, Form, Input } from 'antd';
import { capitalizeFirstLetter } from '/react4xp/mixins/helpers';
import { FileUploadFormItem } from './file-upload-item';

interface LanguageRowProps {
    label: string;
    lang: string;
}

export const LanguageRow = ({ label, lang }: LanguageRowProps) => {
    const fileFieldName = `file${capitalizeFirstLetter(lang)}`;
    const required = ['ru', 'kk'].includes(lang);
    return (
        <Row gutter={16}>
            <Divider
                orientation="left"
                orientationMargin={0}
                style={{ marginBottom: 0 }}
            >
                {label}
            </Divider>
            <Col span={12}>
                <Form.Item
                    name={lang}
                    label="Наименование"
                    rules={[{ required }]}
                >
                    <Input placeholder="Введите наименование" />
                </Form.Item>
            </Col>
            <Col span={12}>
                <FileUploadFormItem
                    required={required}
                    label="Файл"
                    name={fileFieldName}
                />
            </Col>
        </Row>
    );
};
